import { render, staticRenderFns } from "./SoundList.vue?vue&type=template&id=ec74938e&scoped=true&"
import script from "./SoundList.vue?vue&type=script&lang=js&"
export * from "./SoundList.vue?vue&type=script&lang=js&"
import style0 from "./SoundList.vue?vue&type=style&index=0&id=ec74938e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec74938e",
  null
  
)

export default component.exports